/* VD Cart Sync — keeps the cart DRAWER and the card icons in sync after the
 * Temu-style icon adds (assets/vd-card-cart.js), and keeps variant detection
 * correct. Jobs:
 *  1) Re-render the theme cart drawer after an AJAX add (icon bypasses the
 *     theme renderContents to dodge a null-innerHTML crash on collection
 *     pages, so the drawer DOM was never refreshed and showed "empty").
 *  2) Badge every product-card icon whose product is already in the cart.
 *  3) Re-derive each icon's mode from the card's REAL controls: a genuine
 *     'Choose Options' button => variant popup (multi); otherwise an add
 *     button => instant add (single). Quick View is NOT a variant signal, so
 *     single-variant products (Default Title) instant-add and never show a
 *     pointless options popup.
 * Standalone: listens for the global 'ProductAddtoCart' event. */
(function () {
  'use strict';
  if (window.__vdCartSyncInit) return;
  window.__vdCartSyncInit = true;

  function cardHandle(card) {
    var co = card.querySelector('[data-product-handle]');
    if (co && co.getAttribute('data-product-handle')) return co.getAttribute('data-product-handle');
    var a = card.querySelector('.card__media a[href], .card__heading a[href], a.full-unstyled-link[href]');
    var u = a ? a.getAttribute('href') : null;
    if (u) {
      var parts = String(u).split('?')[0].split('/');
      var last = parts[parts.length - 1] || parts[parts.length - 2];
      return last || null;
    }
    return null;
  }

  /* Re-derive mode from the card's own controls. Choose-Options => multi;
     else an add/quick-add submit => single. (Quick View is ignored.) */
  function fixModes() {
    var btns = document.querySelectorAll('.vd-cart-btn');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.classList.contains('vd-soldout')) continue;
      var card = btn.closest('.card-wrapper') || btn.closest('.card');
      if (!card) continue;
      var hasChoose = !!card.querySelector('.product-chooseoptions');
      var hasAdd = !!card.querySelector('product-form button[name="add"], .quick-add__submit');
      var want = hasChoose ? 'multi' : (hasAdd ? 'single' : null);
      if (want && btn.getAttribute('data-vd-mode') !== want) {
        btn.setAttribute('data-vd-mode', want);
        if (want === 'multi') {
          btn.setAttribute('aria-label', 'Choose options');
          btn.title = 'Choose options';
        } else {
          btn.setAttribute('aria-label', 'Add to cart');
          btn.title = 'Add to cart';
        }
      }
    }
  }

  function sectionId(el) {
    var sec = el && el.closest ? el.closest('.shopify-section') : null;
    if (sec && sec.id && sec.id.indexOf('shopify-section-') === 0) {
      return sec.id.slice('shopify-section-'.length);
    }
    return null;
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var secId = sectionId(drawer) || 'cart-drawer';
    fetch('/?section_id=' + encodeURIComponent(secId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            if (fresh.className) drawer.className = fresh.className;
          }
        } catch (e) {}
      })
      .catch(function () {});
  }

  function ensureStyle() {
    if (document.getElementById('vd-incart-style')) return;
    var st = document.createElement('style');
    st.id = 'vd-incart-style';
    st.textContent =
      '.vd-cart-btn.vd-incart{background:#1f8a4c;color:#fff;border-color:#1f8a4c;}' +
      '.vd-cart-btn .vd-cart-count{position:absolute;top:-6px;right:-6px;min-width:18px;height:18px;' +
      'padding:0 4px;box-sizing:border-box;border-radius:9px;background:#1a1a1a;color:#fff;' +
      'font-size:11px;font-weight:700;line-height:18px;text-align:center;' +
      'box-shadow:0 1px 4px rgba(0,0,0,.35);pointer-events:none;}';
    document.head.appendChild(st);
  }

  function applyInCart(btn, qty) {
    var badge = btn.querySelector('.vd-cart-count');
    if (qty > 0) {
      ensureStyle();
      btn.classList.add('vd-incart');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'vd-cart-count';
        btn.appendChild(badge);
      }
      if (badge.textContent !== String(qty)) badge.textContent = qty;
      var multi = btn.getAttribute('data-vd-mode') !== 'single';
      btn.title = 'In cart (' + qty + ') - tap to add' + (multi ? '' : ' another');
      btn.setAttribute('aria-label', 'In cart, quantity ' + qty + '. Tap to add more.');
    } else {
      if (btn.classList.contains('vd-incart')) btn.classList.remove('vd-incart');
      if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
    }
  }

  function syncCartState() {
    fixModes();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var byHandle = {};
        var items = (c && c.items) ? c.items : [];
        for (var i = 0; i < items.length; i++) {
          var h = items[i].handle;
          if (!h) continue;
          byHandle[h] = (byHandle[h] || 0) + (items[i].quantity || 0);
        }
        var btns = document.querySelectorAll('.vd-cart-btn');
        for (var j = 0; j < btns.length; j++) {
          var btn = btns[j];
          if (btn.classList.contains('vd-soldout')) continue;
          var card = btn.closest('.card-wrapper') || btn.closest('.card');
          if (!card) continue;
          var hh = cardHandle(card);
          applyInCart(btn, (hh && byHandle[hh]) ? byHandle[hh] : 0);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('ProductAddtoCart', function () {
    refreshCartDrawer();
    setTimeout(syncCartState, 80);
  });

  function start() { fixModes(); syncCartState(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', function () { fixModes(); setTimeout(syncCartState, 700); });

  try {
    var t, target = document.getElementById('MainContent') || document.body;
    var mo = new MutationObserver(function () {
      fixModes();
      clearTimeout(t);
      t = setTimeout(syncCartState, 450);
    });
    mo.observe(target, { childList: true, subtree: true });
  } catch (e) {}
})();
